import {useEffect} from "react";

import {endLocalSession} from "@/src/modules/auth/lib/end-local-session";
import {
  getSessionInvalidatedReason,
  getSessionInvalidatedUserId,
  shouldIgnoreSessionInvalidated,
} from "@/src/modules/auth/lib/should-ignore-session-invalidated";
import {useSessionStore} from "@/src/modules/auth/store/session";
import {useMeStore} from "@/src/modules/core/store/me";

const SESSION_INVALIDATED_EVENTS = ["session:invalidated", ".session:invalidated"] as const;

export function useSessionInvalidatedRealtime(): void {
  useEffect(() => {
    const onInvalidated = (event: Event) => {
      const detail = (event as CustomEvent<unknown>).detail;
      const eventUserId = getSessionInvalidatedUserId(detail);
      const currentUserId = useMeStore.getState().me?.user_id;

      if (
        eventUserId != null &&
        currentUserId != null &&
        eventUserId !== currentUserId
      ) {
        return;
      }

      const loginAt = useSessionStore.getState().session?.login_at;
      if (shouldIgnoreSessionInvalidated(detail, loginAt)) {
        return;
      }

      endLocalSession({
        reason: getSessionInvalidatedReason(detail),
        source: "websocket",
      });
    };

    for (const eventName of SESSION_INVALIDATED_EVENTS) {
      window.addEventListener(eventName, onInvalidated);
    }

    return () => {
      for (const eventName of SESSION_INVALIDATED_EVENTS) {
        window.removeEventListener(eventName, onInvalidated);
      }
    };
  }, []);
}
